/**
 * Types of Codes
 * @enum
 */
const PaymentCode = {
  DEFAULT_PAYMENT: 'EFT_PAYMENT',
  CREDIT_CARD_PAYMENT: 'DD_CREDIT_CARD',
  BANK_ACCOUNT_PAYMENT: 'DD_BANK_ACCOUNT',
};

export default PaymentCode;